function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.5 40.5"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 20.25,
    cy: 20.25,
    r: 18.75,
    style: {
      fill: "inherit",
      stroke: "currentColor",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "inherit",
      strokeWidth: 2
    },
    d: "m21.23 13.47 6.78 6.78-6.78 6.78M28.01 20.25H12.49"
  }));
};
export default SvgArrow;